angular.module('dpw.components')
    .directive('dpwTooltipBox', [function () {
        return {
            restrict: 'EA',
            scope: {
                text: '@'
            },
            controller: ['$scope', function ($scope) {
                this.isShowTooltip = true;
                this.text = $scope.text;
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-tooltip-box.html'
        };
    }]);